import { useUser } from '@vivaldis/session'
import { useMemo } from 'react'

export const useUserHasWebAccess = (): boolean => {
  const user = useUser()
  return useMemo(() => {
    const permission = user?.permissions.find(
      permission => permission.companyId === user?.company?.id
    )

    const hasHoursValidationPermissionForConstruct =
      permission?.construct4dPermissions?.permissions?.some(
        permission => permission === 'hours_validation'
      )

    const hasHoursValidationPermissionForInterim =
      permission?.interim4dPermissions?.permissions?.some(
        permission => permission === 'hours_validation'
      )

    return !!(
      hasHoursValidationPermissionForConstruct ||
      hasHoursValidationPermissionForInterim
    )
  }, [user?.company?.id, user?.permissions])
}
